export const ROW_CLASS_DRAG = 'drag-hovered'